import { baseColors } from '../components/primitives/colors'

import { makeTransition } from './makeTransition'

export const linkStyles = {
  textDecoration: 'underline',
  fontWeight: 600,
  color: baseColors.contentContent,
  transition: makeTransition('color'),
  cursor: 'pointer',
  '&:hover,&:focus': {
    color: baseColors.contentContent,
  },
}
